import * as React from "react";
import { PropsWithChildren } from "react";
import classes from "./index.module.css";
import { Background } from "@/components/Icons";

interface SourceButtonProps extends PropsWithChildren {
  active?: boolean;
  onClick: () => void;
}

const SourceButton = ({ children, active, onClick }: SourceButtonProps) => (
  <button className={classes.root} onClick={onClick} data-active={active} type="button">
    <Background />
    {children}
  </button>
);

export default SourceButton;
